<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('EditWorkHourDiary') | ToUppercase">
                <small>{{$t('Name') |ToUppercase}}</small><br>
                <vs-input class="w-full" type="text" name="name" v-model="workHourDiary.name"/>

                <vs-upload automatic :action="'/api/excel/workHourDiary/' + $route.params.report_id" :text="$t('UploadExcel')" limit="1" fileName="file" @on-success="successUpload" @on-error="errorUpload"/>

                <div class="mt-6">
                    <vs-button class="mr-2" @click="editWorkHourDiary">{{ $t("Edit") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
        },
        data() {
            return {
                workHourDiary: {}
            };
        },
        methods: {
            updateWorkHourDiary() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/report/' + this.$route.params.report_id + '?type=workHourDiaryReport')
                .then(function (response) {
                    thisIns.workHourDiary = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dnevnih poročil.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            editWorkHourDiary() {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.put('/report/' + this.$route.params.report_id + '?type=workHourDiaryReport', {
                    id: thisIns.workHourDiary.id,
                    name: thisIns.workHourDiary.name
                }).then(function () {
                    thisIns.$vs.notify({
                        text: "Dnevnih delovnih ur shranjen",
                        color: "success",
                    });
                    thisIns.$router.push('/report/workHourDiary');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            successUpload(response) {
                this.$vs.notify({
                    color:'success',
                    text:'Excel uspečno shranjen in PDF generiran'
                })
            },
            errorUpload(response) {
                this.$vs.notify({
                    color:'danger',
                    text: response.target.responseText
                })
            }
        },
        created() {
            this.updateWorkHourDiary();
        },
    };
</script>